<p-dialog
  [visible]="visible"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '580px', padding: '0' }"
  styleClass="fp-match-modal"
  [breakpoints]="{ '640px': '95vw' }"
  showTransitionOptions="'0ms'"
  hideTransitionOptions="'0ms'"
>
  <div class="fp-match-modal__inner">
    <!-- left panel -->
    <div class="fp-match-modal__left">
      <h3 class="fp-match-modal__heading">
        {{ 'DASHBOARD.MATCH_MODAL.HEADING' | translate }}
      </h3>

      <div class="fp-match-modal__avatars">
        <p-avatar
          [image]="matchedUser?.photo || undefined"
          [label]="!matchedUser?.photo ? getInitials((matchedUser?.first_name || '') + ' ' + (matchedUser?.last_name || '')) : undefined"
          styleClass="fp-match-modal__avatar fp-match-modal__avatar--a"
          shape="circle"
        ></p-avatar>

        <p-avatar
          [image]="currentUser?.photo || undefined"
          [label]="!currentUser?.photo ? getInitials((currentUser?.first_name || '') + ' ' + (currentUser?.last_name || '')) : undefined"
          styleClass="fp-match-modal__avatar fp-match-modal__avatar--b"
          shape="circle"
        ></p-avatar>
      </div>

      <p class="fp-match-modal__subtext--name">
        {{
          (userRole === 'ME'
            ? 'DASHBOARD.MATCH_MODAL.SUBTEXT_MENTEE'
            : userRole === 'MR'
              ? 'DASHBOARD.MATCH_MODAL.SUBTEXT_MENTOR'
              : userRole === 'CH'
                ? 'DASHBOARD.MATCH_MODAL.SUBTEXT_COACH'
                : 'DASHBOARD.MATCH_MODAL.SUBTEXT_COACHEE'
          ) | translate: { name: matchedUser?.first_name, lastName: matchedUser?.last_name }
        }}
      </p>
      <p class="fp-match-modal__position">{{ matchedUser?.position }}</p>
      <p class="fp-match-modal__company">{{ matchedUser?.company }}</p>
    </div>

    <!-- right panel -->
    <div class="fp-match-modal__right">
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text p-button-sm fp-match-modal__close"
        (click)="close()"
        aria-label="Close"
      ></button>

      <p class="fp-match-modal__steps-title">
        {{ 'DASHBOARD.MATCH_MODAL.STEPS_TITLE' | translate }}
      </p>

      <ul class="fp-match-modal__steps">
        <li>{{ 'DASHBOARD.MATCH_MODAL.STEP_1_' + userRole | translate }}</li>
        <li>{{ 'DASHBOARD.MATCH_MODAL.STEP_2' | translate }}</li>
        <li>{{ 'DASHBOARD.MATCH_MODAL.STEP_3_' + userRole | translate }}</li>
      </ul>

      <div class="fp-match-modal__bottom-right">
        <span class="fp-match-modal__pagination" *ngIf="total > 1">{{ currentIndex + 1 }} / {{ total }}</span>

        <button
          *ngIf="total > 1"
          pButton
          pRipple
          [label]="'DASHBOARD.MATCH_MODAL.NEXT' | translate"
          class="p-button p-button-text fp-match-modal__next"
          (click)="next()"
          [disabled]="currentIndex + 1 >= total"
        ></button>
      </div>

      <button pButton pRipple [label]="ctaKey | translate" class="p-button p-button-warning fp-match-modal__cta" (click)="cta()"></button>
    </div>
  </div>
</p-dialog>
